module.exports = "images/5ans.77162a62.png";